var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 153C126.869 153 160 119.869 160 79C160 38.1309 126.869 5 86 5C45.1309 5 12 38.1309 12 79C12 119.869 45.1309 153 86 153Z",
    fill: "#EAF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_284_46728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_284_46728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.71 55.111H30.3832C28.2369 55.111 26.4639 53.338 26.4639 51.1917V17.5044C26.4639 15.3582 28.2369 13.5851 30.3832 13.5851H141.71C143.856 13.5851 145.629 15.3582 145.629 17.5044V51.1917C145.629 53.338 143.856 55.111 141.71 55.111Z",
    fill: "url(#paint0_linear_284_46728)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.778 26.5566H59.9644C58.9379 26.5566 58.1914 27.3964 58.1914 28.3296C58.1914 29.3561 59.0313 30.1026 59.9644 30.1026H133.778C134.804 30.1026 135.551 29.2628 135.551 28.3296C135.551 27.3031 134.711 26.5566 133.778 26.5566Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.65 38.5952H59.9644C58.9379 38.5952 58.1914 39.435 58.1914 40.3682C58.1914 41.3013 59.0313 42.1412 59.9644 42.1412H100.65C101.677 42.1412 102.423 41.3013 102.423 40.3682C102.423 39.435 101.677 38.5952 100.65 38.5952Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5416 43.6332C48.6953 43.6332 52.8733 39.4553 52.8733 34.3015C52.8733 29.1478 48.6953 24.9699 43.5416 24.9699C38.3879 24.9699 34.21 29.1478 34.21 34.3015C34.21 39.4553 38.3879 43.6332 43.5416 43.6332Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2.39786,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.741 30.6625C47.1812 30.2893 46.4346 30.3826 46.0614 30.8492L42.702 35.3284L40.7423 33.5554C40.2757 33.0888 39.5292 33.1821 39.0626 33.6487C38.596 34.1153 38.6893 34.8618 39.1559 35.3284L42.0487 37.9412C42.2354 38.1279 42.5153 38.2212 42.8886 38.2212H42.9819C43.3552 38.2212 43.6351 38.0345 43.8218 37.7546L48.021 32.2489C48.3943 31.7823 48.3009 31.0358 47.741 30.6625Z",
    fill: "#AAB2C5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_284_46728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_284_46728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.666 102.34H30.0416C28.0824 102.34 26.4639 100.721 26.4639 98.7622V68.0108C26.4639 66.0515 28.0824 64.433 30.0416 64.433H131.666C133.625 64.433 135.244 66.0515 135.244 68.0108V98.7622C135.244 100.721 133.625 102.34 131.666 102.34Z",
    fill: "url(#paint1_linear_284_46728)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.701 76.2984H57.0463C56.1132 76.2984 55.46 77.045 55.46 77.8848C55.46 78.7247 56.2065 79.4712 57.0463 79.4712H124.607C125.541 79.4712 126.194 78.7247 126.194 77.8848C126.194 77.045 125.541 76.2984 124.701 76.2984Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3725 87.3089H57.0459C56.1127 87.3089 55.4595 88.0554 55.4595 88.8953C55.4595 89.7351 56.206 90.4817 57.0459 90.4817H94.2791C95.2123 90.4817 95.8655 89.7351 95.8655 88.8953C95.8655 88.0554 95.2123 87.3089 94.3725 87.3089Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0226 91.8816C46.7125 91.8816 50.5144 88.0797 50.5144 83.3898C50.5144 78.6999 46.7125 74.8979 42.0226 74.8979C37.3327 74.8979 33.5308 78.6999 33.5308 83.3898C33.5308 88.0797 37.3327 91.8816 42.0226 91.8816Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 1.7984,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_284_46728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_284_46728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.626 142.949H29.3261C27.7587 142.949 26.4639 141.655 26.4639 140.087V115.486C26.4639 113.919 27.7587 112.624 29.3261 112.624H110.626C112.193 112.624 113.488 113.919 113.488 115.486V140.087C113.488 141.655 112.193 142.949 110.626 142.949Z",
    fill: "url(#paint2_linear_284_46728)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.053 122.116H50.9297C50.1832 122.116 49.6606 122.714 49.6606 123.386C49.6606 124.057 50.2579 124.655 50.9297 124.655H104.979C105.725 124.655 106.248 124.057 106.248 123.386C106.248 122.714 105.725 122.116 105.053 122.116Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7906 130.925H50.9293C50.1827 130.925 49.6602 131.522 49.6602 132.194C49.6602 132.866 50.2574 133.463 50.9293 133.463H80.7159C81.4624 133.463 81.985 132.866 81.985 132.194C81.985 131.522 81.4624 130.925 80.7906 130.925Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9106 134.582C42.6625 134.582 45.7041 131.541 45.7041 127.789C45.7041 124.037 42.6625 120.996 38.9106 120.996C35.1587 120.996 32.1172 124.037 32.1172 127.789C32.1172 131.541 35.1587 134.582 38.9106 134.582Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 1.43872,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_284_46728",
    x: 0.0873928,
    y: 0.396907,
    width: 171.918,
    height: 94.2788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.1882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_284_46728",
    x: 0.0873928,
    y: 0.396907,
    width: 171.918,
    height: 94.2788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.1882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_284_46728",
    x: 2.38609,
    y: 52.3942,
    width: 156.935,
    height: 86.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.0389
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0389
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_284_46728",
    x: 2.38609,
    y: 52.3942,
    width: 156.935,
    height: 86.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.0389
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0389
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_284_46728",
    x: 7.20165,
    y: 102.993,
    width: 125.548,
    height: 68.8499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.63111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.63111
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_284_46728",
    x: 7.20165,
    y: 102.993,
    width: 125.548,
    height: 68.8499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.63111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.63111
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_46728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_284_46728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_46728",
    x1: 86.0076,
    y1: 12.6246,
    x2: 86.0076,
    y2: 55.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_46728",
    x1: 80.8184,
    y1: 63.5562,
    x2: 80.8184,
    y2: 102.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_46728",
    x1: 69.9475,
    y1: 111.922,
    x2: 69.9475,
    y2: 143.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/NoDataFound.c08f5dfd50029f63debf00edf5a9a255.svg";
export { ForwardRef as ReactComponent };